import React, { useEffect } from 'react';
import { View, Text, Button } from 'react-native';

export default function FCMComponent() {
  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <Text>Sample React ntive notification</Text>
    </View>
  );
}
